import { useAiStore, useContentLayoutStore } from '../components/zustand-stores';

export const browserPreferencesResetEvent = 'browser-preferences-reset';

export function resetBrowserPreferences(): void {
    useContentLayoutStore.setState({ splitterSizesByPage: {} });
    useAiStore.setState({ preferredLanguage: 'English', responseCache: {} });
    for (const key of ['selected-theme', 'content-layout-splitter', 'ai-storage']) {
        localStorage.removeItem(key);
    }
    window.dispatchEvent(new Event(browserPreferencesResetEvent));
}
